module.exports = __webpack_public_path__ + "static/analytics1-94b7cc37eeb4c4726ca73b9e635c9041.jpg";